export const languages = [
  {
    id: 1,
    name: 'English',
    locale: 'en'
  },
  {
    id: 2,
    name: 'español',
    locale: 'es'
  },
  {
    id: 3,
    name: 'हिंदी',
    locale: 'hi'
  },
  {
    id: 4,
    name: 'italiano',
    locale: 'it'
  },
  {
    id: 5,
    name: 'คนไทย',
    locale: 'th'
  },
  {
    id: 6,
    name: 'português',
    locale: 'pt_br'
  }
]
